import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProfilePage from './pages/Profile';
import LoginPage from './pages/Login';
import SignUp from './pages/SignUp';
import ForgetPassword from './pages/ForgetPassword';
import { AvatarCreationPage } from './pages/AvatarCreation';
import UserDashboard from './pages/UserDashboard';
import Leaderboard from './pages/Leaderboard';
import Hero from './components/Hero';
import { InitialOnboarding } from './pages/Onboarding';
import Unsubscribe from './pages/Unsubscribe';

const AppRoutes = ({ setProfileOption, profileOption }) => (
    <Routes>
        <Route path='/' element={<Hero />} />
        <Route path='/register' element={<SignUp />} />
        <Route path='/forgetPassword' element={<ForgetPassword />} />
        <Route path='/login' element={<LoginPage />} />
        <Route path='/profile' element={<ProfilePage setProfileOption={setProfileOption} profileOption={profileOption} />} />
        <Route path='/onboard' element={<InitialOnboarding />} />
        <Route path='/dashboard' element={<UserDashboard />} />
        <Route path='/leaderboard' element={<Leaderboard />} />
        <Route path='/avatar' element={<AvatarCreationPage />} />
        <Route path='/unsubscribe' element={<Unsubscribe/>} />
    </Routes>
);

export default AppRoutes;
